import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import { MetaPredictionsData } from '../../../../../api/services/mediaPlanning/getMetaPredictionsValidity';

export interface MetaPredictionsTableProps {
  pricingData: MetaPredictionsData;
}

function MetaPredictionsTable({ pricingData }: MetaPredictionsTableProps) {
  const { t } = useTranslation();
  return (
    <Table>
      <TableHead>
        <TableCell />
        <TableCell>
          {t('mediaPlanning.metaBooking.modals.validityCheck.oldMetaPricing')}
        </TableCell>
        <TableCell>
          {t('mediaPlanning.metaBooking.modals.validityCheck.newMetaPricing')}
        </TableCell>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>
            {t('mediaPlanning.metaBooking.modals.validityCheck.budget')}
          </TableCell>
          <TableCell>
            {`${pricingData.value?.existingPrediction?.budget} ${pricingData.value?.existingPrediction?.currency}` ??
              '-'}
          </TableCell>
          <TableCell>
            {`${pricingData.value?.newPrediction?.budget} ${pricingData.value?.newPrediction?.currency}` ??
              '-'}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            {t('mediaPlanning.metaBooking.modals.validityCheck.impressions')}
          </TableCell>
          <TableCell>
            {pricingData.value?.existingPrediction?.impressions ?? '-'}
          </TableCell>
          <TableCell>
            {pricingData.value?.newPrediction?.impressions ?? '-'}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            {t('mediaPlanning.metaBooking.modals.validityCheck.reach')}
          </TableCell>
          <TableCell>
            {pricingData.value?.existingPrediction?.reach ?? '-'}
          </TableCell>
          <TableCell>
            {pricingData.value?.newPrediction?.reach ?? '-'}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

export default MetaPredictionsTable;
